import auth from "@/store/auth.js";

export default {
    namespaced: true,

    state: {
        reviews: {
            sent: {}, received: {}
        }, replies_count: 1
    },

    getters: {
        reviews: state => state.reviews
    },

    actions: {
        /**
         @returns {Promise<Object>}
         */

        async getMovingReviews ({ state }) {
            if (auth.state.user.isCustomer) {
                const { sent, received } = await axios.get('/customer/order-reviews');
                state.reviews.sent = sent;
                state.reviews.received = received;
            } else {
                const { sent, received } = await axios.get('/order-reviews');
                state.reviews.sent = sent;
                state.reviews.received = received;
            }
        },

        async getDeliveryReviews ({ state }) {
            if (auth.state.user.isCustomer) {
                const { sent, received } = await axios.get('/customer/delivery-reviews');
                state.reviews.sent = sent;
                state.reviews.received = received;
            } else {
                const { sent, received } = await axios.get('/delivery-reviews');
                state.reviews.sent = sent;
                state.reviews.received = received;
            }
        },

        async reply ({ dispatch }, { review_id, comment }) {
            await axios.post(`/reviews/${ review_id }/reply`, { comment });

            await dispatch('index');
        },

        async helper_edit ({ dispatch }, { review_id, star, comment }) {
            await axios.put(`/reviews/${ review_id }`, {
                star, comment
            });

            await dispatch('index');
        },

        async customer_edit ({ dispatch }, { review_id, star, comment }) {
            await axios.put(`/customer/reviews/${ review_id }`, {
                star, comment
            });

            await dispatch('index');
        },

        async helper_publish ({ dispatch }, review_id) {
            await axios.post(`/reviews/${ review_id }/publish`);

            await dispatch('index');
        },

        async customer_publish ({ dispatch }, review_id) {
            await axios.post(`/customer/reviews/${ review_id }/publish`);

            await dispatch('index');
        },

        async get_helper_order_reviews (_, order_id) {
            return await axios.get(`/orders/${ order_id }/reviews`);
        },

        async get_customer_order_reviews (_, order_id) {
            return await axios.get(`/customer/orders/${ order_id }/reviews`)
        },

        async get_reviews_from_helpers_to_customer (_, customer_id) {
            return await axios.get(`/reviews/customer-received/${ customer_id }`);
        },

        async get_reviews_from_customers_to_helper (_, delivery_id) {
            return await axios.get(`customer/deliveries/${ delivery_id }/acceptor-reviews`);
        },

        async set_review_to_helper_delivery ({ dispatch }, { delivery_id, star, comment }) {
            await axios.post(`/customer/deliveries/${ delivery_id }/reviews`, {
                star, comment
            });
        },

        async get_review_to_helper_delivery(_, delivery_id) {
            return await axios.get(`/customer/deliveries/${ delivery_id }/show-review`);
        },

        async set_review_to_customer_delivery ({ dispatch }, { delivery_id, star, comment }) {
            await axios.post(`/deliveries/${ delivery_id }/reviews`, {
                star, comment
            });
        },

        async get_review_to_customer_delivery(_, delivery_id) {
            return await axios.get(`/deliveries/${ delivery_id }/show-review`);
        },
    }
}
